<section class="card-bg relative overflow-hidden rounded-2xl dark:bg-surface-1/60" [class.pb-24]="selectedIds().length > 0">
  <div class="space-y-6 px-5 py-6 md:px-8 md:py-8">
    <app-unpaid-partner-overview-cards
      [data]="overview()"
      [loading]="loading()"
      [calculating]="overviewCalculating()"
      [payAllLabel]="payAllButtonLabel()"
      [payAllDisabled]="paying() || payableCount() === 0 || selectedIds().length > 0"
      [payUrgentDisabled]="paying() || overview().urgentPaymentsCount === 0"
      [showUrgentAction]="showUrgentOverviewAction"
      [showAskPrismAi]="false"
      (payAllToBusiness)="payAllToBusiness()"
      (payUrgent)="payAllUrgentVisible()"
    >
      <app-unpaid-payments-is-dummy-toggle
        overview-header-actions
        (dummyChange)="onIsDummyToggle($event)"
      ></app-unpaid-payments-is-dummy-toggle>
    </app-unpaid-partner-overview-cards>

    <section
      class="relative z-10 mt-4 rounded-[14px] bg-white p-4 shadow-[0_1px_4px_0_rgba(0,0,0,0.1)] dark:border-surface-3 dark:bg-surface-1"
    >
      <div class="flex flex-wrap items-end gap-2 pb-0.5">
        <div class="min-w-[10.5rem] max-w-[12rem] shrink-0 flex-[1_1_10.5rem]">
          <label class="mb-1.5 block text-[12px] font-medium text-[#7d7d93] dark:text-ink-muted">Search</label>
          <div class="flex h-[38px] overflow-hidden rounded-[10px] border border-[#d1d5dc] bg-white dark:border-surface-3 dark:bg-surface-0">
            <div class="relative min-w-0 flex-1">
              <input
                class="h-full w-full border-0 bg-transparent pl-9 pr-2 text-[14px] text-[#38385b] outline-none placeholder:text-[#7d7d93] focus:ring-0 dark:text-ink-soft dark:placeholder:text-ink-subtle"
                [ngModel]="search()"
                (ngModelChange)="search.set($event)"
                (keyup.enter)="applyFilters()"
                placeholder="Search..."
              />
              <app-icon-v2
                name="search"
                size="16"
                class="pointer-events-none absolute inset-y-0 left-2.5 my-auto text-[#7d7d93] dark:text-ink-muted"
              ></app-icon-v2>
            </div>
            @if (searchApplied()) {
              <button
                type="button"
                class="shrink-0 border-l border-[#d1d5dc] px-2.5 text-[12px] font-semibold text-[#38385b] transition hover:bg-[#f8f8f8] dark:border-surface-3 dark:text-ink-soft dark:hover:bg-surface-3"
                (click)="clearSearch()"
              >
                Clear
              </button>
            }
          </div>
        </div>

        <div class="relative z-[28] w-[9.5rem] shrink-0">
          <label class="mb-1.5 block text-[12px] font-medium text-[#7d7d93] dark:text-ink-muted">Start date</label>
          <app-selection
            mode="date-picker"
            [enableYearMonthPicker]="true"
            [disableFutureDates]="true"
            minDate="2017-01-01"
            [ngModel]="startDate()"
            (ngModelChange)="onStartDateChange($event)"
            [maxDate]="startDateMax()"
            datePlaceholder="Start date"
          ></app-selection>
        </div>

        <div class="relative z-[27] w-[9.5rem] shrink-0">
          <label class="mb-1.5 block text-[12px] font-medium text-[#7d7d93] dark:text-ink-muted">End date</label>
          <app-selection
            mode="date-picker"
            [enableYearMonthPicker]="true"
            [disableFutureDates]="true"
            [ngModel]="endDate()"
            (ngModelChange)="onEndDateChange($event)"
            [minDate]="startDate()"
            [maxDate]="endDateMax()"
            datePlaceholder="End date"
          ></app-selection>
        </div>

        <div class="w-[16rem] shrink-0">
          <label class="mb-1.5 block text-[12px] font-medium text-[#7d7d93] dark:text-ink-muted">Filter</label>
          <div class="relative z-[30]">
            <app-dropdown
              [options]="filterDropdownOptions"
              [selectedValue]="fmFilterDropdownValue()"
              selectionMode="single"
              placeholder="Filter"
              variant="themeBase"
              customHeight="'38px'"
              size="sm"
              [rounded]="'md'"
              [fullWidth]="true"
              [showTooltip]="false"
              chevronIcon="chevron-down"
              [tooltipFixedStrategy]="true"
              menuClass="!z-[200] shadow-xl min-w-[240px]"
              (selectionChange)="onFilterDropdownChange($event)"
            ></app-dropdown>
          </div>
        </div>

        <div class="w-[7.25rem] shrink-0">
          <label class="mb-1.5 block text-[12px] font-medium text-[#7d7d93] dark:text-ink-muted">Type</label>
          <div class="relative z-[29]">
            <app-dropdown
              [options]="vipDropdownOptions"
              [selectedValue]="vipTypeDropdownValue()"
              selectionMode="single"
              placeholder="Type"
              variant="themeBase"
              customHeight="'38px'"
              size="sm"
              [rounded]="'md'"
              [fullWidth]="true"
              [showTooltip]="false"
              chevronIcon="chevron-down"
              [tooltipFixedStrategy]="true"
              menuClass="!z-[200] shadow-xl"
              (selectionChange)="onVipDropdownChange($event)"
            ></app-dropdown>
          </div>
        </div>

        <div class="flex h-[38px] shrink-0 items-center self-end pb-0.5">
          <app-toggle
            [checked]="urgentOnly()"
            label="Urgent only"
            labelPosition="after"
            size="sm"
            className="shrink-0 whitespace-nowrap"
            (toggleChange)="setUrgentOnly($event)"
          ></app-toggle>
        </div>

        <div class="ml-auto flex shrink-0 items-end gap-2 self-end">
          <div class="relative z-[30]">
            <app-dropdown
              [options]="exportDropdownOptions"
              selectionMode="single"
              selectionStyle="none"
              variant="themeBase"
              [fullWidth]="false"
              className="!w-auto"
              [showTooltip]="false"
              [tooltipFixedStrategy]="true"
              [menuFixed]="false"
              menuClass="!z-[200] min-w-[160px] shadow-xl"
              (selectionChange)="onExportDropdownChange($event)"
            >
              <span
                appDropdownTrigger
                tabindex="0"
                role="button"
                class="inline-flex h-[38px] cursor-pointer items-center gap-2 rounded-[8px] bg-[#f2f5f8] px-4 text-[13px] font-bold uppercase tracking-[0.04em] text-[#38385b] transition hover:bg-[#e8ecf1] dark:bg-surface-3 dark:text-ink-soft dark:hover:bg-surface-3"
                [class.pointer-events-none]="exporting() || !totalCount()"
                [class.opacity-60]="exporting() || !totalCount()"
              >
                <app-icon-v2 name="external-link" size="16" class="text-[#38385b] dark:text-ink-soft"></app-icon-v2>
                {{ exporting() ? 'Exporting...' : 'EXPORT' }}
              </span>
            </app-dropdown>
          </div>
          <app-button variant="primary" size="md" [maxHeight]="'38px'" (click)="applyFilters()">Apply</app-button>
          <button
            type="button"
            class="inline-flex h-[38px] items-center gap-1.5 rounded-[10px] border border-[#d1d5dc] bg-white px-4 text-[14px] font-semibold text-[#38385b] transition hover:bg-[#f8f8f8] dark:border-surface-3 dark:bg-surface-0 dark:text-ink-soft dark:hover:bg-surface-3"
            (click)="resetFilters()"
          >
            Reset
          </button>
        </div>
      </div>
    </section>

    <div
      class="relative z-0 min-h-[400px] overflow-visible rounded-[14px] bg-white shadow-[0_1px_4px_0_rgba(0,0,0,0.1)] dark:border-surface-3 dark:bg-surface-1"
    >
      @if (tableBusy()) {
        <div
          class="absolute inset-0 z-10 flex items-center justify-center overflow-hidden rounded-[14px] bg-white/60 backdrop-blur-sm dark:bg-surface-1/60"
        >
          <div class="flex flex-col items-center gap-4">
            <div class="h-10 w-10 animate-spin rounded-full border-4 border-purple-600 border-t-transparent"></div>
            <p class="animate-pulse font-bold text-slate-600 dark:text-slate-400">{{ tableBusyMessage() }}</p>
          </div>
        </div>
      }

      <div class="" [class.pointer-events-none]="tableBusy()" [class.opacity-50]="tableBusy()">
        @if (!tableBusy() && !payments().length) {
          <div class="flex min-h-[280px] flex-col items-center justify-center px-4 py-12 text-center">
            <svg width="138" height="81" viewBox="0 0 138 81" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path
                d="M129.789 70.1323H2.66082C1.95537 70.1315 1.27904 69.8553 0.780215 69.3643C0.281386 68.8733 0.000794248 68.2076 0 67.5132V2.61905C0.000819236 1.92468 0.281418 1.25899 0.780242 0.767996C1.27907 0.277004 1.95538 0.000806374 2.66082 0H129.789C130.494 0.000782547 131.171 0.276972 131.67 0.76797C132.168 1.25897 132.449 1.92467 132.45 2.61905V67.5132C132.449 68.2076 132.168 68.8733 131.67 69.3643C131.171 69.8553 130.494 70.1315 129.789 70.1323ZM2.66082 0.582011C2.11214 0.582616 1.5861 0.797426 1.19812 1.17931C0.810146 1.5612 0.591909 2.07898 0.591294 2.61905V67.5132C0.591934 68.0533 0.810183 68.5711 1.19816 68.9529C1.58613 69.3348 2.11215 69.5496 2.66082 69.5503H129.789C130.338 69.5496 130.864 69.3348 131.252 68.9529C131.64 68.571 131.858 68.0533 131.859 67.5132V2.61905C131.858 2.07899 131.64 1.56123 131.252 1.17934C130.864 0.797463 130.338 0.582641 129.789 0.582011H2.66082Z"
                fill="#EAEAEA"
              />
              <path
                d="M110.3 43.9258C116.673 42.7288 122.804 46.9346 123.997 53.3135C124.591 56.491 123.844 59.6074 122.161 62.084L136.68 75.9404C137.724 76.9357 137.777 78.5832 136.802 79.6445C135.757 80.7811 133.97 80.7843 132.922 79.6533H132.921L119.35 64.9941C117.987 65.9865 116.388 66.6992 114.623 67.0303C108.249 68.2274 102.118 64.0217 100.926 57.6426C99.731 51.2611 103.927 45.1229 110.3 43.9258ZM120.618 53.9512C119.775 49.4382 115.439 46.4668 110.935 47.3105C106.43 48.1545 103.462 52.497 104.305 57.0107C105.148 61.5236 109.483 64.4942 113.988 63.6504C118.493 62.8065 121.461 58.4648 120.618 53.9512Z"
                fill="#AD46FF"
                stroke="white"
              />
            </svg>
            <h3 class="mb-2 text-[22px] font-bold text-[#141437] dark:text-white">No Data Found</h3>
            <p class="text-[16px] text-[#7d7d93] dark:text-ink-muted">No matching records found. Please change your search</p>
          </div>
        }

        @if (payments().length) {
          <app-paginated-table
            [headers]="tableHeaders"
            [tableData]="payments()"
            [isCheckboxShow]="true"
            [selection]="selectedRows()"
            [isRowSelectable]="canSelectRowBind"
            (selectionChange)="onSelectionChange($event)"
            [serverSide]="true"
            [totalItems]="totalCount()"
            [pageCount]="totalPages()"
            [currentPage]="page()"
            [pageSize]="pageSize"
            (pageChange)="goToPage($event)"
            [tableKey]="'recuvery-unpaid-' + fmFilter()"
            [tableWrapperClass]="'h-full !overflow-visible rounded-2xl dark:bg-surface-1 bg-white'"
            containerClass="!overflow-visible"
            [cellTemplates]="{
              accountId: accountIdTemplate,
              businessOwner: businessOwnerTemplate,
              businessOwnerEmail: businessOwnerEmailTemplate,
              paymentDate: paymentDateTemplate,
              partnerName: partnerNameTemplate,
              partnerEmail: partnerEmailTemplate,
              recurringAmount: recurringAmountTemplate,
              transferAmount: transferAmountTemplate,
              bankAdded: bankAddedTemplate,
              action: actionTemplate
            }"
          ></app-paginated-table>
        }
      </div>
    </div>
  </div>
</section>

<ng-template #accountIdTemplate let-row>
  <span class="text-[14px] font-semibold text-[#141437] dark:text-white">{{ getAccountCode(row) }}</span>
</ng-template>

<ng-template #businessOwnerTemplate let-row>
  <div class="flex flex-wrap items-center gap-2">
    <span class="text-[14px] text-[#141437] dark:text-white">{{ getBusinessOwnerName(row) }}</span>
    @if (isVip(row)) {
      <span
        class="inline-flex w-max items-center gap-1 rounded-full bg-[#fff9e8] px-2 py-0.5 text-[11px] font-semibold text-[#ffa514] dark:bg-[#4b3817] dark:text-[#ffd37a]"
      >
        <app-icon-v2 name="gem" size="10" customClass="text-[#ffa514]"></app-icon-v2>
        VIP
      </span>
    }
  </div>
</ng-template>

<ng-template #businessOwnerEmailTemplate let-row>
  <span class="text-[14px] text-[#7d7d93] dark:text-ink-muted">{{ getBusinessOwnerEmail(row) }}</span>
</ng-template>

<ng-template #paymentDateTemplate let-row>
  <span class="text-[14px] text-[#141437] dark:text-white">{{ getPaymentDate(row) }}</span>
</ng-template>

<ng-template #partnerNameTemplate let-row>
  <span class="text-[14px] text-[#141437] dark:text-white">{{ getPartnerName(row) }}</span>
</ng-template>

<ng-template #partnerEmailTemplate let-row>
  <span class="text-[14px] text-[#7d7d93] dark:text-ink-muted">{{ getPartnerEmail(row) }}</span>
</ng-template>

<ng-template #recurringAmountTemplate let-row>
  <span class="text-[14px] font-semibold tabular-nums text-[#141437] dark:text-white">
    ${{ getAmountCharged(row) | number : '1.2-2' }}
  </span>
</ng-template>

<ng-template #transferAmountTemplate let-row>
  <div class="flex flex-col items-start gap-1">
    <span class="text-[14px] font-semibold tabular-nums text-[#141437] dark:text-white">
      ${{ getPayableAmount(row) | number : '1.2-2' }}
    </span>
    @if (isUrgent(row)) {
      <span
        class="inline-flex w-max items-center gap-1 rounded-full bg-[#f4e5ff] px-2 py-0.5 text-[11px] font-medium text-[#ad46ff] dark:bg-purple-800 dark:text-white"
      >
        <app-icon-v2 name="zap" size="10" customClass="text-[#ad46ff] fill-current"></app-icon-v2>
        Urgent Payment
      </span>
    }
  </div>
</ng-template>

<ng-template #bankAddedTemplate let-row>
  <div class="text-[14px] text-[#141437] dark:text-white">
    {{ getBankAdded(row) }}
    @if (row['transfers_disabled'] != 1 && (fmFilter() === 5 || fmFilter() === 8 || fmFilter() === 10)) {
      <span class="mt-1 block text-[12px] text-[#f05050] dark:text-[#ff9090]">(Transfer Disabled)</span>
    }
  </div>
</ng-template>

<ng-template #actionTemplate let-row>
  <div class="flex items-center justify-start gap-2" data-row-action-menu-root (click)="$event.stopPropagation()">
    <button
      type="button"
      class="inline-flex h-8 items-center justify-center rounded-[8px] bg-[#AD46FF] px-4 text-[13px] font-medium text-white transition hover:bg-[#962ef7] disabled:cursor-not-allowed disabled:opacity-60"
      [disabled]="isRowActionsDisabled() || !canPayRow(row)"
      (click)="paySingle(row)"
    >
      Pay
    </button>
    @if (getDisplayRowMenuOptions(row).length) {
      <div class="relative z-[1]">
        <button
          type="button"
          class="flex h-8 w-8 items-center justify-center rounded-[8px] border border-[#dfe5ed] bg-white text-[#7d7d93] hover:bg-[#f8f8f8] disabled:cursor-not-allowed disabled:opacity-60 dark:border-surface-3 dark:bg-surface-1 dark:text-ink-muted dark:hover:bg-surface-3"
          [disabled]="isRowActionsDisabled()"
          [attr.aria-expanded]="isActionMenuOpen(row)"
          aria-haspopup="true"
          (click)="toggleActionMenu(row, $event)"
        >
          <app-icon-v2 name="ellipsis-vertical" size="16"></app-icon-v2>
        </button>
      </div>
    }
  </div>
</ng-template>

@if (openActionMenuRow() && actionMenuPosition(); as menuPos) {
  <div class="fixed inset-0 z-[150]" (click)="closeActionMenu()" aria-hidden="true"></div>
  <div
    #actionMenuPanel
    data-row-action-menu-root
    class="fixed z-[200] w-[220px] overflow-hidden rounded-[10px] border border-[#e5e7eb] bg-white py-1 shadow-xl dark:border-surface-3 dark:bg-surface-1"
    [style.top.px]="menuPos.top"
    [style.left.px]="menuPos.left"
    (click)="$event.stopPropagation()"
  >
    @for (option of getDisplayRowMenuOptions(openActionMenuRow()!); track option.value) {
      <button
        type="button"
        class="flex w-full items-center gap-2 px-3 py-2 text-left text-[13px] text-[#38385b] transition hover:bg-[#f2f5f8] dark:text-ink-soft dark:hover:bg-surface-3"
        (click)="onRowMenuOptionSelect(option.value, openActionMenuRow()!, $event)"
      >
        @if (option.icon) {
          <app-icon-v2
            [name]="option.icon"
            size="16"
            [customClass]="option.iconClass || 'text-[#7d7d93] dark:text-ink-muted'"
          ></app-icon-v2>
        }
        <span>{{ option.label }}</span>
      </button>
    }
  </div>
}

<div
  class="bulk-selection-footer fixed bottom-0 right-0 z-[100] border-t border-[#e5e7eb] bg-white p-4 shadow-[0_-4px_10px_0_rgba(0,0,0,0.05)] transition-[transform,opacity] duration-300 ease-out will-change-transform dark:border-surface-3 dark:bg-surface-1"
  [class.bulk-selection-footer--visible]="selectedIds().length > 0"
  [attr.aria-hidden]="selectedIds().length === 0"
  [style.left]="'var(--sidebar-width, 0px)'"
>
  <div class="mx-auto flex flex-col items-start gap-4 px-4 xl:flex-row xl:items-center xl:justify-between xl:px-8">
    <div class="flex flex-col">
      <div class="text-[24px] font-bold leading-tight text-[#141437] tabular-nums dark:text-white">
        {{ totalSelectedAmount() | currency }}
      </div>
      <div class="mt-1 flex flex-wrap items-center gap-4 text-[13px] text-[#7d7d93] dark:text-ink-muted">
        <div class="flex items-center gap-1.5">
          <app-icon-v2 name="building" size="14"></app-icon-v2>
          Paying to
          <span class="font-semibold text-[#141437] dark:text-white">{{ selectedBusinessesCount() }}</span>
          businesses
        </div>
        <span class="text-[#e5e7eb] dark:text-surface-3">|</span>
        <div class="flex items-center gap-1.5">
          <app-icon-v2 name="receipt" size="14"></app-icon-v2>
          <span class="font-semibold text-[#141437] dark:text-white">{{ selectedPayableCount() }}</span>
          Payments
        </div>
        @if (selectedUrgentCount() > 0) {
          <div class="flex items-center gap-1.5 rounded-full bg-[#f4e5ff] px-2.5 py-0.5 text-[#ad46ff] dark:bg-purple-800/20">
            <app-icon-v2 name="zap" size="14" strokeWidth="2.5"></app-icon-v2>
            <span class="font-semibold">
              {{ selectedUrgentCount() }} urgent payments - {{ selectedUrgentAmount() | currency }}
            </span>
          </div>
        }
      </div>
    </div>

    <div class="flex items-center gap-3">
      @if (moreOptions().length) {
        <app-dropdown
          [options]="moreOptions()"
          selectionMode="single"
          selectionStyle="none"
          [clearable]="false"
          [disabled]="paying() || markingUrgent()"
          variant="outline"
          size="md"
          position="top-left"
          placeholder="More"
          [fullWidth]="false"
          customWidth="180px"
          menuTitle="More Options"
          menuClass="!z-[200] shadow-xl"
          (selectionChange)="onMoreOptionClick($event)"
        >
          <button
            appDropdownTrigger
            type="button"
            class="inline-flex h-11 items-center gap-2 rounded-[10px] border border-[#AD46FF] bg-white px-5 text-[14px] font-medium text-[#AD46FF] transition hover:border-[#962ef7] hover:bg-[#faf5ff] hover:text-[#962ef7] dark:border-purple-500 dark:bg-surface-1 dark:text-purple-400 dark:hover:border-line-strong dark:hover:bg-surface-3 dark:hover:text-white"
          >
            More
          </button>
        </app-dropdown>
      }

      <button
        type="button"
        class="inline-flex h-11 items-center rounded-[10px] bg-[#AD46FF] px-6 text-[14px] font-medium text-white transition hover:bg-[#962ef7] disabled:cursor-not-allowed disabled:opacity-60"
        [disabled]="paying() || !selectedPayableCount()"
        (click)="paySelected()"
      >
        {{ paying() ? 'Processing...' : 'Make Payments' }}
      </button>
    </div>
  </div>
</div>
